import { render, staticRenderFns } from "./detail-form.vue?vue&type=template&id=ea660a34&scoped=true&"
import script from "./detail-form.vue?vue&type=script&lang=js&"
export * from "./detail-form.vue?vue&type=script&lang=js&"
import style0 from "./detail-form.vue?vue&type=style&index=0&id=ea660a34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea660a34",
  null
  
)

component.options.__file = "detail-form.vue"
export default component.exports